module.exports = __webpack_public_path__ + "static/pokemon-e7c855e53764fbb09cb50d32c02ea420.mp4";